<template>
    <BaseBoxSection :title="__('buyer-recipient')" :helpName="helpName">
        <ContractorDisplayForm :contractor="contractor" :displayDetails="displayDetails"/>

        <div class="col-md-12 m-b-xs mt-2">
            <label>
                <input
                    :checked="recipient"
                    :disabled="true"
                    type="checkbox"
                > {{ __('recipient-data-show') }}
            </label>
        </div>

        <ContractorDisplayForm v-if="hasRecipient" :contractor="recipient" :displayDetails="displayDetails"/>

    </BaseBoxSection>
</template>

<script>
import BaseBoxSection from "../BaseBoxSection";
import ContractorDisplayForm from "./ContractorDisplayForm";

export default {
    name: "ContractorDisplayBox",
    components: {ContractorDisplayForm, BaseBoxSection},
    props: {
        contractor: {
            type: Object,
            required: true,
        },
        recipient: {
            type: Object,
            default: null,
        },
        displayDetails: {
            type: Boolean,
            default: true,
        },
        helpName: {
            type: String,
            required: true,
        },
    },
    computed: {
        hasRecipient() {
            return this.recipient != null;
        },
    },
};
</script>
